import { render, staticRenderFns } from "./input-block.html?vue&type=template&id=980138e2&scoped=true&"
import script from "./input-block.js?vue&type=script&lang=js&"
export * from "./input-block.js?vue&type=script&lang=js&"
import style0 from "./input-block.scss?vue&type=style&index=0&id=980138e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980138e2",
  null
  
)

export default component.exports